import { rangesIntersect, filterHash, memoize, mapHash, isPropsEqual, memoizeOutput, combineEventUis } from '@fullcalendar/core';
import { __assign } from 'tslib';
import { computeResourceEditable } from './EventDragging';
var ResourceDataAdder = /** @class */ (function () {
    function ResourceDataAdder() {
        this.filterResources = memoize(filterResources);
    }
    ResourceDataAdder.prototype.transform = function (viewProps, viewSpec, calendarProps, allOptions) {
        if (viewSpec.class.needsResourceData) {
            return {
                resourceStore: this.filterResources(calendarProps.resourceStore, allOptions.filterResourcesWithEvents, calendarProps.eventStore, calendarProps.dateProfile.activeRange),
                resourceEntityExpansions: calendarProps.resourceEntityExpansions
            };
        }
    };
    return ResourceDataAdder;
}());
export { ResourceDataAdder };
function filterResources(resourceStore, doFilterResourcesWithEvents, eventStore, activeRange) {
    if (doFilterResourcesWithEvents) {
        var instancesInRange = filterEventInstancesInRange(eventStore.instances, activeRange);
        var hasEvents_1 = computeHasEvents(instancesInRange, eventStore.defs);
        __assign(hasEvents_1, computeAncestorHasEvents(hasEvents_1, resourceStore));
        return filterHash(resourceStore, function (resource, resourceId) {
            return hasEvents_1[resourceId];
        });
    }
    else {
        return resourceStore;
    }
}
function filterEventInstancesInRange(eventInstances, activeRange) {
    return filterHash(eventInstances, function (eventInstance) {
        return rangesIntersect(eventInstance.range, activeRange);
    });
}
function computeHasEvents(eventInstances, eventDefs) {
    var hasEvents = {};
    for (var instanceId in eventInstances) {
        var instance = eventInstances[instanceId];
        for (var _i = 0, _a = eventDefs[instance.defId].resourceIds; _i < _a.length; _i++) {
            var resourceId = _a[_i];
            hasEvents[resourceId] = true;
        }
    }
    return hasEvents;
}
/*
mark resources as having events if any of their ancestors have them
NOTE: resourceStore might not have all the resources that hasEvents{} has keyed
*/
function computeAncestorHasEvents(hasEvents, resourceStore) {
    var res = {};
    for (var resourceId in hasEvents) {
        var resource = void 0;
        while ((resource = resourceStore[resourceId])) {
            resourceId = resource.parentId; // now functioning as the parentId
            if (resourceId) {
                res[resourceId] = true;
            }
            else {
                break;
            }
        }
    }
    return res;
}
// for when non-resource view should be given EventUi info (for event coloring/constraints based off of resource data)
var ResourceEventConfigAdder = /** @class */ (function () {
    function ResourceEventConfigAdder() {
        this.buildResourceEventUis = memoizeOutput(buildResourceEventUis, isPropsEqual);
        this.injectResourceEventUis = memoize(injectResourceEventUis);
    }
    ResourceEventConfigAdder.prototype.transform = function (viewProps, viewSpec, calendarProps) {
        if (!viewSpec.class.needsResourceData) { // is a non-resource view?
            return {
                eventUiBases: this.injectResourceEventUis(viewProps.eventUiBases, viewProps.eventStore.defs, this.buildResourceEventUis(calendarProps.resourceStore))
            };
        }
    };
    return ResourceEventConfigAdder;
}());
export { ResourceEventConfigAdder };
function buildResourceEventUis(resourceStore) {
    return mapHash(resourceStore, function (resource) {
        return resource.ui;
    });
}
function injectResourceEventUis(eventUiBases, eventDefs, resourceEventUis) {
    return mapHash(eventUiBases, function (eventUi, defId) {
        if (defId) { // not the '' key
            return injectResourceEventUi(eventUi, eventDefs[defId], resourceEventUis);
        }
        else {
            return eventUi;
        }
    });
}
function injectResourceEventUi(origEventUi, eventDef, resourceEventUis) {
    var parts = [];
    // first resource takes precedence, which fights with the ordering of combineEventUis, thus the unshifts
    for (var _i = 0, _a = eventDef.resourceIds; _i < _a.length; _i++) {
        var resourceId = _a[_i];
        if (resourceEventUis[resourceId]) {
            parts.unshift(resourceEventUis[resourceId]);
        }
    }
    parts.unshift(origEventUi);
    return combineEventUis(parts);
}
// for making sure events that have editable resources are always draggable in resource views
export function transformIsDraggable(val, eventDef, eventUi, view) {
    if (!val) {
        if (view.viewSpec.class.needsResourceData) {
            if (computeResourceEditable(eventDef, view.context.calendar)) { // yuck
                return true;
            }
        }
    }
    return val;
}
